import { ReportDataOption } from '../../types';

export const useDataOptionsTranslations = () => {
  /**
   * TODO: Work in Progress - @navjotahuja92
   * This is a temporary solution will be replaced with actual values and keys.
   */
  const dataOptionsTranslations: { [key in ReportDataOption]: string } = {
    [ReportDataOption.DATA_OPTION_1]: 'DATA_OPTION_1',
    [ReportDataOption.DATA_OPTION_2]: 'DATA_OPTION_2',
    [ReportDataOption.DATA_OPTION_3]: 'DATA_OPTION_3',
    [ReportDataOption.DATA_OPTION_4]: 'DATA_OPTION_4',
    [ReportDataOption.DATA_OPTION_5]: 'DATA_OPTION_5',
    [ReportDataOption.DATA_OPTION_6]: 'DATA_OPTION_6',
    [ReportDataOption.DATA_OPTION_7]: 'DATA_OPTION_7',
    [ReportDataOption.DATA_OPTION_8]: 'DATA_OPTION_8',
  };

  const dataOptionsDescriptionsTranslations: { [key in ReportDataOption]: string } = {
    [ReportDataOption.DATA_OPTION_1]: 'data_option_1_description',
    [ReportDataOption.DATA_OPTION_2]: 'data_option_2_description',
    [ReportDataOption.DATA_OPTION_3]: 'data_option_3_description',
    [ReportDataOption.DATA_OPTION_4]: 'data_option_4_description',
    [ReportDataOption.DATA_OPTION_5]: 'data_option_5_description',
    [ReportDataOption.DATA_OPTION_6]: 'data_option_6_description',
    [ReportDataOption.DATA_OPTION_7]: 'data_option_7_description',
    [ReportDataOption.DATA_OPTION_8]: 'data_option_8_description',
  };

  return { dataOptionsTranslations, dataOptionsDescriptionsTranslations };
};
